import { render, staticRenderFns } from "./InjectedTool.vue?vue&type=template&id=524e8c69&scoped=true&"
import script from "./InjectedTool.vue?vue&type=script&lang=ts&"
export * from "./InjectedTool.vue?vue&type=script&lang=ts&"
import style0 from "./InjectedTool.vue?vue&type=style&index=0&id=524e8c69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e8c69",
  null
  
)

export default component.exports